import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=2da3e6df&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
import style0 from "./Register.scss?vue&type=style&index=0&id=2da3e6df&prod&scoped=true&lang=scss&external"
import style1 from "./Register.vue?vue&type=style&index=1&id=2da3e6df&prod&lang=scss"
import style2 from "./Register.vue?vue&type=style&index=2&id=2da3e6df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da3e6df",
  null
  
)

export default component.exports